module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/caste-verification/caste-verification-grid/caste-verification-grid.component.css
// module id = ./src/app/caste-verification/caste-verification-grid/caste-verification-grid.component.css
// module chunks = main